import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.0_@babel+core@7.29.0_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
